import { seasonTicketsSelector } from 'booking/selectors'
import { createSelector } from 'reselect'

export const brazilTicketsSelector = createSelector(seasonTicketsSelector, tickets =>
    tickets.map(t => ({
        prdctName: t.rateName,
        prdctLongDesc: t.shortDescription,
        prdctCd: t.id,
        ratePlans: [
            {
                price: t.amount,
                name: t.rateType,
                ratePlanId: t.id,
                currencySymbol: t.currencySymbol,
                ...t,
            },
        ],
    }))
)
